import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// 从 localStorage 读取保存的语言设置
const savedLanguage = localStorage.getItem('language') || 'zh';

// 动态导入所有翻译文件
const modules = import.meta.glob('./local/*/*.ts', { eager: true });

const resources: Record<string, Record<string, unknown>> = {};

Object.keys(modules).forEach((path) => {
  const match = path.match(/\.\/local\/([^/]+)\/([^/]+)\.ts$/);
  if (match) {
    const [, lang, ns] = match;
    const module = modules[path] as { default?: unknown };
    if (!resources[lang]) {
      resources[lang] = {};
    }
    if (module.default) {
      resources[lang][ns] = module.default;
    }
  }
});

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLanguage,
    fallbackLng: 'zh',
    defaultNS: 'common',
    keySeparator: '.',
    nsSeparator: ':',
    interpolation: {
      escapeValue: false,
    },
  });

// 监听语言变化，保存到 localStorage
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('language', lng);
});

export default i18n;
